export default function segmentsToString(segments) {
  if (!segments) {
    return '';
  }

  return segments.reduce((acc, val) => acc + val.text, '');
}
